import { IoSearchOutline } from "react-icons/io5";
import { setValueSearchFilter, getValueSearchFilter, translate } from "../utils/Common";
import { BsList, BsGrid3X3GapFill } from "react-icons/bs";
import { useEffect, useState } from "react";
import SortSwitch from "./SortSwitch";
import { TbSortAscending, TbSortDescending } from "react-icons/tb";
import styles from "./SearchBoxItems.module.css";


const SearchBoxItems = ({ itemsArray, itemsFound, setItemsShowing, setItemsFiltered, setView, view, itemName, filterType }) => {
    // obtener el sessionStorage.setItem("valueSearchFilter", value);
    const [searchValue, setSearchValue] = useState(getValueSearchFilter() || '');
    
    const [sortField, setSortField] = useState(localStorage.getItem('sortField') || 'ocupationLocker');
    const [sortOrder, setSortOrder] = useState(localStorage.getItem("sortOrder") || "asc");

    const handleSortOrderChange = (newOrder) => {
        setSortOrder(newOrder);
        localStorage.setItem("sortOrder", newOrder);
        handleSort(sortField, newOrder);
      };

      const handleSort = (field, order = sortOrder) => {
        setSortField(field);
        localStorage.setItem("sortField", field);
    
        const listToSort = itemsFound.length > 0 ? itemsFound : itemsArray;
    
        const sortedItems = [...listToSort].sort((a, b) => {
          if (a[field] < b[field]) return order === "asc" ? -1 : 1;
          if (a[field] > b[field]) return order === "asc" ? 1 : -1;
          return 0;
        });
    
        setItemsFiltered(sortedItems);
      };
    

    // Opciones de sortType por filterType
    const sortOptions = {
        platform: [
            { value: 'locationName', label: translate("dashboard.platforms.name") },
            { value: 'ocupationLocker', label: translate("global.currentOccupation")},
            { value: 'boxitLocationId', label: translate("global.lockerId") },
            {value: 'locationId', label: translate("dashboard.platforms.support.openLockerCard.locationId")},
        ],
        package: [],
    };
    
    const filterByPackage = (value, item) => {
        const upperCaseValue = value.toUpperCase();
        return (
            item.Nro_Id?.toUpperCase().includes(upperCaseValue) ||
            item.NroIdentificacion?.toUpperCase().includes(upperCaseValue) ||
            item.NumeroTracking?.toUpperCase().includes(upperCaseValue) ||
            item.Cliente?.toUpperCase().includes(upperCaseValue) ||
            item.Direccion?.toUpperCase().includes(upperCaseValue) ||
            item.Email?.toUpperCase().includes(upperCaseValue) ||
            item.zipCode?.toUpperCase().includes(upperCaseValue) ||
            item.NumeroIdentificacion?.toUpperCase().includes(upperCaseValue) ||
            item.Plataforma?.toUpperCase().includes(upperCaseValue) 
        );
    };

    const filterByPlatform = (value, item) => {
        const upperCaseValue = value.toUpperCase();
        return (
            item.locationName?.toUpperCase().includes(upperCaseValue) ||
            item.locationId?.toUpperCase().includes(upperCaseValue) ||
            item.zipCode?.toUpperCase().includes(upperCaseValue) ||
            item.Plataforma?.toUpperCase().includes(upperCaseValue) ||
            String(item?.boxitLocationId)?.toUpperCase().includes(upperCaseValue)
        );
    };

    const filterByAlerts = (value, item) => {
        const upperCaseValue = value.toUpperCase();
        return (
            item.NumeroTracking?.toUpperCase().includes(upperCaseValue) ||
            item.Email?.toUpperCase().includes(upperCaseValue) ||
            item.NombreCompleto?.toUpperCase().includes(upperCaseValue) ||
            String(item.IdCliente)?.includes(upperCaseValue)
        );
    };
    
const handleResetValueSarch = () => {
    handleSearchBoxFilter('');
    setSearchValue('');
    setItemsFiltered(itemsArray);
};
    
const handleSearchBoxFilter = (value) => {
    setValueSearchFilter(value);
    setSearchValue(value);

    if (itemsArray?.length) {
      let filteredItems;

      switch (filterType) {
        case "package":
          filteredItems = itemsArray.filter((item) => filterByPackage(value, item));
          break;
        case "platform":
          filteredItems = itemsArray.filter((item) => filterByPlatform(value, item));
          break;
        case "alerts":
          filteredItems = itemsArray.filter((item) => filterByAlerts(value, item));
          break;
        default:
          filteredItems = itemsArray;
      }

      const sortedFilteredItems = [...filteredItems].sort((a, b) => {
        if (a[sortField] < b[sortField]) return sortOrder === "asc" ? -1 : 1;
        if (a[sortField] > b[sortField]) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });

      setItemsFiltered(sortedFilteredItems);
    }
  };
    
    useEffect(() => {
        if (itemsFound.length > 0) {
            handleSort(sortField);  
        }

        if (searchValue) {
            handleSearchBoxFilter(searchValue);
        }

    }, [itemsArray]);    

    return (
        <div className={styles.toolbar}>
            <div className={styles.mainRow}>
                <div className={styles.itemsPerPage}>
                    <select
                        onChange={(e) => setItemsShowing(Number(e.target.value))}
                        className={styles.select}
                    >
                        <option value={itemsFound?.length >= 20 ? 20 : itemsFound?.length}>
                            {(itemsFound?.length >= 20 ? 20 : itemsFound?.length) || 0} {translate("global.show")}
                        </option>
                        {itemsFound?.length > 20 && (
                            <option value={(itemsFound?.length > 20 && itemsFound?.length <= 40) ? itemsFound?.length : 40}>
                                {(itemsFound?.length > 20 && itemsFound?.length <= 40) ? itemsFound?.length : 40} {translate("global.show")}
                            </option>
                        )}
                        {itemsFound?.length > 40 && (
                            <option value={(itemsFound?.length > 40 && itemsFound?.length <= 60) ? itemsFound?.length : 60}>
                                {(itemsFound?.length > 40 && itemsFound?.length <= 60) ? itemsFound?.length : 60} {translate("global.show")}
                            </option>
                        )}
                    </select>
                </div>

                <div className={styles.searchWrapper}>
                    <input
                        type="text"
                        placeholder={translate("global.search")}
                        className={styles.searchInput}
                        onChange={(e) => handleSearchBoxFilter(e.target.value || "")}
                        value={searchValue}
                    />
                    <div className={styles.searchIcon}>
                        <IoSearchOutline size={18} />
                        {searchValue && (
                            <button
                                type="button"
                                className={styles.clearButton}
                                onClick={handleResetValueSarch}
                                aria-label={translate("global.clean") || "Clear"}
                            >
                                &times;
                            </button>
                        )}
                    </div>
                </div>

                {sortOptions[filterType] && sortOptions[filterType].length > 0 && (
                    <div className={styles.sortWrapper}>
                        <span className={styles.sortIcon}>
                            {sortOrder === "asc" ? <TbSortAscending size={16} /> : <TbSortDescending size={16} />}
                        </span>
                        <select
                            className={styles.select}
                            onChange={(e) => {
                                const field = e.target.value;
                                handleSort(field);
                            }}
                            value={sortField}
                        >
                            <option value="" disabled>
                                {translate("global.select") || "Select"}
                            </option>
                            {sortOptions[filterType]?.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                        <SortSwitch sortOrder={sortOrder} onChange={handleSortOrderChange} />
                    </div>
                )}
            </div>

            {itemName === translate("global.deliveries") && (
                <div className={styles.viewToggleRow}>
                    <span className={styles.viewLabel}>{translate("global.toSeenIn")}:</span>
                    <div className={styles.viewToggleGroup}>
                        <button
                            type="button"
                            className={`${styles.viewButton} ${view === "grid" ? styles.viewButtonActive : ""}`}
                            onClick={() => setView("grid")}
                            aria-label="Grid view"
                        >
                            <BsGrid3X3GapFill size={14} />
                        </button>
                        <button
                            type="button"
                            className={`${styles.viewButton} ${view !== "grid" ? styles.viewButtonActive : ""}`}
                            onClick={() => setView("list")}
                            aria-label="List view"
                        >
                            <BsList size={14} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default SearchBoxItems;